import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWSContext } from '../../../contexts/WebSocketContext';

export default function PosicaoFila({ navigate, userData }) {
  const routerNavigate = useNavigate();
  const {
    posicaoAtendimento,
    showModalLoginClient,
    handleSendMessageAutomatica,
    handleCancelQueue,
  } = useWSContext();

  useEffect(() => {
    if (!showModalLoginClient) {
      routerNavigate('/app/chat');
      handleSendMessageAutomatica(userData);
    }
  }, [showModalLoginClient, routerNavigate, handleSendMessageAutomatica, userData]);

  const handleCancel = () => {
    handleCancelQueue();
    navigate(4);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        textAlign: 'center',
        marginY: 5,
      }}
    >
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
        Estamos quase lá! Um de nossos atendentes estará com você em instantes.
        Obrigado por aguardar.
      </Typography>

      <Typography
        variant="body1"
        sx={{
          fontSize: '1.4rem',
          color: 'text.primary',
          mb: 2,
        }}
      >
        {posicaoAtendimento > 0
          ? `Você é o ${posicaoAtendimento}º da fila.`
          : 'Entrando na fila...'}
      </Typography>

      <CircularProgress sx={{ mb: 2 }} />

      <Button
        variant="outlined"
        sx={{ alignSelf: 'center', width: { xs: '80%', sm: '50%' } }}
        onClick={handleCancel}
      >
        Cancelar
      </Button>
    </Box>
  );
}
